import { Table } from 'react-bootstrap';
import { IManagingLinuxServiceInstance } from '../../api/models';
import { Checkbox } from '../../areas/app/Checkbox';
import { LinuxServiceAction } from '../../constants/LinuxServiceAction';
import { ScopedUserPrincipal } from '../../permissions/ScopedUserPrincipal';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ServerApplicationClientEventSummary } from '../../signalr/models';
import { EmptyDataRow } from '../UIExtentions/TableUtilities';
import { LinuxServiceActionHandlerProps } from './LinuxServicesServerManagementView';
import { LinuxServicesServerRow } from './LinuxServicesServerRow';

interface LinuxServicesServerTableProps {
    userPrincipal: UserPrincipal;
    serversUserPrincipal: ScopedUserPrincipal;
    allServersSelectionChanged: (selected: boolean) => void;
    serverSelectionChanged: (selected: boolean, serverName: string) => void;
    onClickCallback: (props: LinuxServiceActionHandlerProps) => Promise<void>;
    serverApps: IManagingLinuxServiceInstance[];
    servers: string[];
    allSelected: boolean;
    onTimeoutCallback: (data: ServerApplicationClientEventSummary) => void;
}
export const LinuxServicesServerTable = ({
    userPrincipal,
    serversUserPrincipal,
    allServersSelectionChanged,
    serverSelectionChanged,
    onClickCallback,
    serverApps,
    servers,
    allSelected,
    onTimeoutCallback,
}: LinuxServicesServerTableProps) => {
    return (
        <Table striped size="sm">
            <thead>
                <tr>
                    <th scope="col" className="col-1">
                        <Checkbox selected={allSelected} selectionChangedCallback={allServersSelectionChanged} />
                    </th>
                    <th scope="col" className="col-4">
                        Name
                    </th>
                    <th scope="col" className="col-1">
                        Env.
                    </th>
                    <th scope="col" className="col-1">
                        Load State
                    </th>
                    <th scope="col" className="col-1">
                        Active State
                    </th>
                    <th scope="col" className="col-1">
                        Sub State
                    </th>
                    <th scope="col" className="col-1">
                        Refresh
                    </th>
                    <th scope="col" className="col-2">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {serverApps !== null && serverApps.length > 0 ? (
                    serverApps.map(function (serverApp: IManagingLinuxServiceInstance) {
                        const selected = servers.includes(serverApp.serverName);
                        return (
                            <LinuxServicesServerRow
                                serverApp={serverApp}
                                key={serverApp.serverId}
                                selected={selected}
                                userPrincipal={userPrincipal}
                                serverUserPrincipal={serversUserPrincipal?.getUserPrincipal(serverApp.serverName)}
                                selectionChangedCallback={serverSelectionChanged}
                                onClickCallback={async (action: LinuxServiceAction) =>
                                    await onClickCallback({
                                        serviceName: serverApp.name,
                                        servers: [serverApp.serverName],
                                        action: action,
                                    })
                                }
                                onTimeoutCallback={onTimeoutCallback}
                            />
                        );
                    })
                ) : (
                    <EmptyDataRow colSpan={8} />
                )}
            </tbody>
        </Table>
    );
};
